import React from 'react';
import { useRecoilValue } from 'recoil';

import { OverlayLoader } from '@Calix-Commerce/design-system/components';
import { notifySpinnerTimeout } from 'connectors/bugsnag';
import { loadingState } from 'state/atoms';

const LoaderOverlay = () => {
  const isLoading = useRecoilValue(loadingState);

  const timeoutLimit = parseInt(process.env.REACT_APP_SPINNER_TIME_LIMIT);

  return (
    <OverlayLoader
      isLoading={isLoading}
      timeoutLimit={timeoutLimit}
      timeoutAction={() => notifySpinnerTimeout(timeoutLimit)}
    />
  );
};

export { LoaderOverlay };
